<template>
  <!-- title 详情标题取后台配置 -->
  <a-drawer
    :title="`${
      consultInfo?.consultOrderInfo?.consultType
        ? consultTypeMap[consultInfo.consultOrderInfo.consultType]
        : '咨询'
    }详情`"
    placement="right"
    v-model:visible="visible"
    :width="420"
    :body-style="{ padding: '20px' }"
    destroyOnClose
  >
    <a-spin :spinning="loading" tip="数据加载中...">
      <div class="consultCardInfo" v-if="consultInfo">
        <a-descriptions title="" layout="horizontal">
          <a-descriptions-item :span="3" v-if="consultInfo?.confirmTime">
            <a-alert
              :message="`${
                consultInfo?.confirmStatus === 1 ? '确认咨询时间：' : '调整咨询时间：'
              }${moment(consultInfo?.confirmTime).format('MM月DD日 HH:mm')}`"
              type="warning"
            />
          </a-descriptions-item>
          <a-descriptions-item label="就诊人" :span="3">
            {{ consultInfo?.patientName }}
            {{
              [0, 1].includes(consultInfo?.patientGender)
                ? consultInfo?.patientGender === 1
                  ? '男'
                  : '女'
                : ''
            }}
            {{ parseInt(consultInfo?.patientAge) > 0 ? consultInfo?.patientAge + '岁' : '' }}
          </a-descriptions-item>
          <a-descriptions-item label="联系电话" :span="3">
            {{ consultInfo.patientPhone || '--' }}
          </a-descriptions-item>
          <a-descriptions-item label="患者期望时间" :span="3">
            {{ getMomentTime(consultInfo) || '--' }}
          </a-descriptions-item>
          <a-descriptions-item label="咨询备注" :span="3" v-if="consultInfo?.talkTimeRemark">
            {{ consultInfo?.talkTimeRemark || '--' }}
          </a-descriptions-item>
          <a-descriptions-item label="病情描述" :span="3">
            {{ consultInfo?.description || '--' }}
          </a-descriptions-item>
          <a-descriptions-item :span="3" v-if="consultInfo?.checkListImages?.length">
            <a-image-preview-group>
              <div class="img-list">
                <div
                  v-for="(img, index) in consultInfo?.checkListImages"
                  :key="index"
                  class="img-item"
                >
                  <a-image
                    :src="img"
                    :alt="`图片 ${index + 1}`"
                    class="preview-img"
                    preview="true"
                    width="77"
                  />
                </div>
              </div>
            </a-image-preview-group>
          </a-descriptions-item>
          <a-descriptions-item label="咨询类型" :span="3">
            {{ consultTypeMap[consultInfo?.consultOrderInfo?.consultType] || '' }}
            {{ consultInfo?.consultOrderInfo?.paymentAmount / 100 || '' }}元/{{
              consultInfo?.consultOrderInfo?.originalDuration
            }}分钟
          </a-descriptions-item>
          <a-descriptions-item label="支付时间" :span="3">
            {{ consultInfo?.consultOrderInfo?.payTime || '--' }}
          </a-descriptions-item>
        </a-descriptions>
        <div class="list" v-if="consultInfo?.bdCallDoctorRecordsText?.length > 0">
          <div class="title">BD沟通记录：</div>
          <div class="listBody">
            <div
              v-for="(item, index) in consultInfo.bdCallDoctorRecordsText"
              :key="index"
              class="listItem"
            >
              {{ item }}
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <a-empty v-if="!loading" :image="simpleImage" />
      </div>
    </a-spin>
  </a-drawer>
</template>

<script setup>
import { Empty } from 'ant-design-vue'
const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE
import { ref, defineProps, defineExpose } from 'vue'
import { getConsultInfo } from '@/api/chat'
import moment from 'moment'
const consultTypeMap = {
  1: '视频咨询',
  2: '电话咨询'
}
const props = defineProps({
  info: {
    type: Object,
    default: () => ({})
  }
})
const visible = ref(false)
const consultInfo = ref(null)
const loading = ref(false)
const getMomentTime = consultInfo => {
  const { expectedStartTime, expectedEndTime } = consultInfo || {}
  if (!expectedStartTime || !expectedEndTime) {
    return ''
  }
  const expectTimeObj = {
    momentTime: moment(expectedStartTime).format('MM月DD日'),
    momentTimeStart: moment(expectedStartTime).format('HH:mm'),
    momentTimeEnd: moment(expectedEndTime).format('HH:mm')
  }
  return `${expectTimeObj.momentTime} ${expectTimeObj.momentTimeStart} - ${expectTimeObj.momentTimeEnd}`
}
const initData = async () => {
  visible.value = true
  loading.value = true
  const params = {
    consultId: props.info.consultId
  }
  try {
    getConsultInfo(params)
      .then(res => {
        consultInfo.value = res || {}
      })
      .finally(() => {
        loading.value = false
      })
  } catch (error) {
    consultInfo.value = null
    loading.value = false
  }
}
defineExpose({
  initData
})
</script>

<style lang="scss" scoped>
.consultCardInfo {
  .list {
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    .listBody {
      background: #f5f5f5;
      padding: 12px;
      border-radius: 12px;
      margin-top: 10px;
    }

    .title {
      font-size: 14px;
    }
    .listItem {
      margin-bottom: 10px;
    }
    .listItem:last-child {
      margin-bottom: 0;
    }
  }

  .img-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    padding-left: 70px;
  }
  .img-item {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    background: #f4f4f4;
    border: 1px solid #f0f0f0;
    width: 77px;
    height: 77px;
  }
}
</style>
